import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { FaGlobeAmericas } from 'react-icons/fa';

const LanguageSelector = ({ darkMode }) => {
    const { i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);

    const languages = [
        { code: 'es', name: 'Español' },
        { code: 'en', name: 'English' }
    ];

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        // Guardar la preferencia de idioma en localStorage
        localStorage.setItem('preferredLanguage', lng);
        setIsOpen(false);
    };

    // Cierra el menú cuando se hace clic fuera de él
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="relative inline-block text-left" ref={menuRef}>
            <div>
                <button
                    type="button"
                    className={`flex items-center px-3 py-2 rounded-md text-sm font-medium ${
                        darkMode
                            ? 'text-gray-300 hover:bg-gray-700 hover:text-white'
                            : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
                    } transition-colors`}
                    id="language-menu-button"
                    aria-expanded={isOpen}
                    aria-haspopup="true"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <FaGlobeAmericas className="mr-2" />
                    {languages.find(lang => lang.code === i18n.language)?.name || 'Idioma'}
                </button>
            </div>

            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -10 }}
                        transition={{ duration: 0.2 }}
                        className={`absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md shadow-lg ${
                            darkMode ? 'bg-gray-700' : 'bg-white'
                        } ring-1 ring-black ring-opacity-5 focus:outline-none`}
                        role="menu"
                        aria-orientation="vertical"
                        aria-labelledby="language-menu-button"
                        tabIndex="-1"
                    >
                        <div className="py-1" role="none">
                            {languages.map((language) => (
                                <button
                                    key={language.code}
                                    onClick={() => changeLanguage(language.code)}
                                    className={`block w-full text-left px-4 py-2 text-sm ${
                                        i18n.language === language.code
                                            ? darkMode
                                                ? 'bg-gray-600 text-cyan-400'
                                                : 'bg-gray-100 text-cyan-600'
                                            : darkMode
                                                ? 'text-gray-300 hover:bg-gray-600'
                                                : 'text-gray-700 hover:bg-gray-100'
                                    }`}
                                    role="menuitem"
                                    tabIndex="-1"
                                >
                                    {language.name}
                                </button>
                            ))}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default LanguageSelector;